import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormOtherDocumentTemplate from './form-other-document-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { CreateOtherDocumentItemTemplate } from 'works/legacy/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function CreateOtherDocumentTemplate({
  dismiss,
  worksListTemplateId,
  form,
}) {
  const handleMutationCompletion = (response) => {
    if (response.createOtherDocumentItemTemplate.errors) {
      addErrorsToForm(form, response.createOtherDocumentItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item created!');
      dismiss();
    }
  };

  const [createOtherDoc] = useMutation(CreateOtherDocumentItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to create Compliance Item. Please try again.'
      ),
  });

  const handleSubmit = (values) => {
    createOtherDoc({
      variables: {
        worksListTemplateId: worksListTemplateId,
        input: values,
      },
    });
  };

  return (
    <FormOtherDocumentTemplate
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      initialValues={{ active: true, expirationType: 'NON_EXPIRABLE' }}
      showExpiration
      form={form}
    />
  );
}

CreateOtherDocumentTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  worksListTemplateId: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
};
